import { useNavigate } from "react-router-dom";
import { BackBtn } from "../../components/commonComponents";
import { Button, Card, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { DepartmentModal } from "./components/modals/DepartmentModal";
import { getDepartments, statusChangeDepartment } from "./components/actions";
import { DepartmentCard } from "./components/cards/DepartmentCard";
import { useAppContext } from "../../hooks/useAppContext";

export default function DepartmetPage() {
    const navigate = useNavigate();
    const [open,setOpen] = useState(false);
    const[openEdit,setOpenEdit] = useState(false);
    const [departments,setDepartments] = useState([]);
    const [loading,setLoading] = useState(false);
    const [department,setDepartment] = useState(null);


    const {refreshMenu}=useAppContext()

    const reload = () => {
        getDepartments().then(res => {
            setDepartments(res)
        }).catch(err => {
            console.log(err)
        })
    }

    const statusChange = (id,status) => {
        statusChangeDepartment(id,status).then(res => {
            reload()
            refreshMenu()
        }).catch(err => {
            console.log(err)
        })
    }

    const editDepartment = (data) => {
        setDepartment(data)
        setOpenEdit(true)
    }

    useEffect(() => {
       reload()
    },[])

    return (
        <div>
            <BackBtn path='/admin' label='დაბრუნება' />
            <Card style={{width:'100%',boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'}} title='დეპარტამენტები'>
            <Row gutter={[15, 15]} justify='center'>
                <Col span={24}>
                   <Button icon={<i className="fa-solid fa-folder-plus"></i>} type="primary" onClick={() => {setOpen(true)}}>დეპარტამენტის დამატება</Button>
                </Col>
                    {departments.map((department) => (
                        <Col  key={department.id} style={{alignSelf:'center',justifySelf:'center', display:'flex'}} >
                        <DepartmentCard department={department} statusChange={statusChange} editDepartment={editDepartment} />
                </Col>
                    ))}
            </Row>
            {open && <DepartmentModal open={open} close={() => {setOpen(false)}} reload={() => {reload()}} />}
            {openEdit && <DepartmentModal open={openEdit} close={() => {setOpenEdit(false)}} reload={() => {reload()}} data={department}/>}
                    </Card>
        </div>
    )
}